import React from 'react';
import useCanvas from 'components/canvas/hooks/use-canvas';
import { useCanvasStagePosition } from 'state/canvas/stage';
import { SurfaceNodeUnion } from 'graphql/types';

export default function useNodeWithAbsolutePosition(node: SurfaceNodeUnion) {
  const { findShapeById } = useCanvas();

  const stagePosition = useCanvasStagePosition();

  const nodeRef = React.useRef<any>(node);

  React.useEffect(() => {
    const nodeShape = findShapeById(node.id);

    const absolutePosition = nodeShape?.getAbsolutePosition();

    if (absolutePosition) {
      nodeRef.current = { ...node, absolutePosition };
    }
  }, [stagePosition.x, stagePosition.y, node.updatedAt]);

  return nodeRef.current;
}
